import {
  getResponseByMode,
  showMessage,
  logMessage,
  start,
  end,
} from '../utils';
import {
  CategoryAction
} from '../const';

export class SortProducts {
  constructor(container) {
    this._form = container.querySelector('#sort_count');
    this._select = this._form.querySelector('#order');
    if (this._select === null) {
      return;
    }
    this._selectChangeHandler = this._selectChangeHandler.bind(this);

    this._select.removeAttribute('onchange');
  }

  getElem() {
    return this._form;
  }

  setSelectChangeHandler(callback) {
    if (this._select !== null) {
      this._callback = callback;
      this._form.addEventListener('change', this._selectChangeHandler);
    }
  }

  _selectChangeHandler() {

    const mock = {
      url: 'mocks/products.html',
      options: {
        method: 'GET'
      }
    };

    const formData = new FormData(this._form);
    formData.set('order', this._select.value);
    formData.set('ajax', 1);

    const real = {
      url: this._form.action,
      options: {
        method: 'POST',
        body: formData
      }
    };

    const {
      url,
      options
    } = getResponseByMode(mock, real);

    start();

    fetch(url, options)
      .then((response) => {
        if (response.ok) {
          return response.text();
        }
        throw new Error(`Не получилось обновить товары`);
      })
      .then((str) => {
        this._callback(CategoryAction.SORT, str);
      })
      .catch((error) => {
        console.warn(error);
        logMessage(error);
        showMessage(error.message);
      })
      .finally(() => {
        end();
      });
  }
}
